import BigCharts from './BigCharts';

export default BigCharts;
